import React, { useEffect, useState } from 'react';
import { Flex, Button } from '@chakra-ui/react';

const INVALID_VARIANT = 'outlinePrimary';
const HALF_VALID_VARIANT = 'lightPrimary';
const VALID_VARIANT = 'darkPrimary';

export default function Variant2({
  buttonType = 'button',
  fieldsToWatch,
  changeStateValidCount,
  activeValidCount,
  text,
  isLoading,
  getValues,
  watch,
  width,
  onClick = () => {},
}) {
  const [variant, setVariant] = useState(INVALID_VARIANT);

  const detectButtonState = (value) => {
    let validCount = 0;
    let newVariant = INVALID_VARIANT;
    fieldsToWatch.forEach((field) => {
      if (value[field]) {
        validCount++;
      }
    });

    if (validCount >= changeStateValidCount) {
      newVariant = HALF_VALID_VARIANT;
    }

    if (validCount >= activeValidCount) {
      newVariant = VALID_VARIANT;
    }

    setVariant(newVariant);
  };

  useEffect(() => {
    const defaultValues = getValues(fieldsToWatch);
    const sanitizedDefaultValues = {};
    defaultValues.forEach(
      (defaultValue, index) => (sanitizedDefaultValues[fieldsToWatch[index]] = defaultValue)
    );
    detectButtonState(sanitizedDefaultValues);

    const subscription = watch((value) => {
      detectButtonState(value);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Flex justifyContent="center" mt={'4 !important'}>
      <Button
        type={buttonType}
        w={width}
        size="lg"
        fontSize="xl"
        borderRadius="30px"
        isDisabled={variant !== VALID_VARIANT || isLoading}
        variant="filledBig"
        isLoading={isLoading}
        onClick={onClick}
        _hover={{ bg: 'primary.500', color: 'white' }}
      >
        {text}
      </Button>
    </Flex>
  );
}
